import React from "react";
import {
  XBadge,
  XDivider,
  XDownOutlined,
  XDropdown,
  XHeaderTopRight,
} from "./HeaderStyle";
import { LogoutOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import InitialsAvatar from "../InitialsAvatar/InitialsAvatar";
import { getUserData } from "../../utils/permissions";

const HeaderTop = () => {
  const userData = getUserData();
  const userName = userData?.name || "User";
  const items = [
    {
      key: "1",
      label: <Link>Log Out</Link>,
      icon: <LogoutOutlined />,
    },
  ];
  return (
    <XHeaderTopRight>
      <XBadge>
        <img src="/images/bell-icon.svg" alt="bell" />
      </XBadge>
      <XDivider type="vertical" />
      <XDropdown
        menu={{
          items,
        }}
        arrow
        placement="topRight"
      >
        <div className="d-flex align-items-center gap-2">
          <InitialsAvatar name={userName} size={40} />
          <span className="hideMob">{userName}</span>
          <XDownOutlined />
        </div>
      </XDropdown>
    </XHeaderTopRight>
  );
};

export default HeaderTop;
